module.exports = __webpack_public_path__ + "img/darwin-black-webfont.2e21bf6.svg";